import { TableHeader } from '../types';

const special = Symbol('isSpecialHeader');

export const insertBlankHeaderAndCellsHeader: TableHeader = { label: '_blank_', column: NaN, [special]: true } as TableHeader;
export const insertBlankCellsHeader: TableHeader = { label: '_placeholder_', column: NaN, [special]: true } as TableHeader;
export const allocationHeader: TableHeader = { label: '_allocation_', column: NaN, [special]: true } as TableHeader;

export function isSpecialHeader(header: TableHeader): boolean {
  return !!header && header[special] === true;
}
